export const WIN_LINES_CYCLING_CONDITION = Symbol('WIN_LINES_CYCLING_CONDITION');

/**
 * Optional DI hook (WIN_LINES_CYCLING_CONDITION): lets a provider/game suppress
 * the endless win line cycling played in the regularSpins state. When no
 * implementation is registered, cycling is always allowed.
 */
export interface WinLinesCyclingCondition {
  get isCyclingAllowed(): boolean;
}
